import angular from "angular";
import { AssetsExplorerModel, Lang } from "Roblox";

const assetsExplorerConfig = function ($stateProvider, $urlRouterProvider, $locationProvider, languageResourceProvider) {
    languageResourceProvider.setLanguageKeysFromFile(Lang["Feature.Inventory"]);
    languageResourceProvider.setLanguageKeysFromFile(Lang["Common.AssetTypes"]);
    languageResourceProvider.setLanguageKeysFromFile(Lang["CommonUI.Controls"]);

    var makeUrlFriendly = function (str) {
        return str.split(' ').join('-').toLowerCase();
    };

    var getCategoryUrl = function (category) {
        // category url, e.g. /accessories
        return "/" + makeUrlFriendly(category.name);
    };

    var getSubcategoryUrl = function (category, subcategory) {
        // subcategory url, e.g. /accessories/hair-accessories
        return "/" + makeUrlFriendly(category.name) + "/" + makeUrlFriendly(subcategory.name);
    };

    if (typeof AssetsExplorerModel === "undefined") {
        throw new Error("Roblox.AssetsExplorerModel should be defined");
    }
    var assetCategories = AssetsExplorerModel.assetCategories;
    var defaultCategory = AssetsExplorerModel.defaultCategory;

    //validate url
    var loc = window.location.href;
    if (loc.indexOf("#") !== -1 && loc.indexOf("#!") === -1) {
        window.location.href = loc.replace("#", "#!");
    }
    // false mean hashbang mode
    $locationProvider.html5Mode(false);
    $locationProvider.hashPrefix('!');

    // default state
    $urlRouterProvider.otherwise(getCategoryUrl(defaultCategory));

    for (var tabIndex = 0; tabIndex < assetCategories.length; tabIndex++) {
        var category = assetCategories[tabIndex];
        $stateProvider.state(category.name, {
            url: getCategoryUrl(category),
            // custom parameters
            category: category,
            subcategory: category.items[0]
        });

        var items = category.items;
        for (var subcategoryIndex = 0; subcategoryIndex < items.length; subcategoryIndex++) {
            var subcategory = items[subcategoryIndex];
            $stateProvider.state(category.name + "/" + subcategory.name, {
                url: getSubcategoryUrl(category, subcategory),
                // custom parameters
                category: category,
                subcategory: subcategory
            });
        }
    }
};

const assetsExplorer = angular.module("assetsExplorer", ["robloxApp", "assetsExplorerAppTemplates", "ui.bootstrap", "thumbnails", "cursorPagination", "ui.router", "cursorPagination", "verticalMenu"])
  .config(["$stateProvider", "$urlRouterProvider", "$locationProvider", "languageResourceProvider", assetsExplorerConfig]);

export default assetsExplorer;
